module.exports = __webpack_public_path__ + "static/media/qrcode-ios.ddb801cc.webp";